export default __webpack_public_path__ + "static/media/verifiedMerchantPublic.78344470.svg";